/**
 * 一维数组转树形结构
 * @param list
 * @param pid 最上级id
 * @returns {*}
 */
export const arrToTree = (list, pid = 0) => {
  return list.reduce((res, item) => {
    if (item["p_id"] === pid) {
      item.children = arrToTree(list, item["id"]);
      return res.concat(item);
    }
    return res;
  }, []);
};

// 树形结构转一维数组
export const treeToArr = (list) => {
  return list.reduce((res, item) => {
    res.push(item);
    if (item.children && item.children.length > 0) {
      let _list = treeToArr(item.children);
      return res.concat(_list);
    }
    return res;
  }, []);
};

// 去重
export const filterRepeat = (list) => {
  return list.reduce((res, item) => {
    let _index = res.findIndex((v) => v.id === item.id);
    if (_index < 0) {
      return res.concat(item);
    }
    return res;
  }, []);
};

// 树形结构转一维数组 - 针对账户管理处使用
export const treeToArrAccount = (list) => {
  return list.reduce((res, item) => {
    res.push(item);
    if (item.permission && item.permission.length > 0) {
      let _list = treeToArrAccount(item.permission);
      return res.concat(_list);
    }
    return res;
  }, []);
};
